document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab');
  const tabContents = document.querySelectorAll('.tab-content');
  const paginationDots = document.querySelectorAll('.pagination-dot');

  let currentIndex = 0;
  const totalTabs = tabs.length;

  function updateActiveState(index) {
    tabs.forEach((tab) => tab.classList.remove('active'));
    tabContents.forEach((content) => content.classList.remove('active'));
    paginationDots.forEach((dot) => dot.classList.remove('active'));

    tabs[index].classList.add('active');
    tabContents[index].classList.add('active');
    paginationDots[index].classList.add('active');

    currentIndex = index;
  }

  paginationDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      updateActiveState(index);
    });
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      updateActiveState(index);
    });
  });
});
